import type {
  AgentDocUpdate,
  ClientActionRef,
} from '@streamlain/copilot-realtime-contract';

type Provenance = { agent?: AgentDocUpdate; clientAction?: ClientActionRef };
type Run = Provenance & { updates: Uint8Array[] };

export function provenanceRuns(
  jobs: readonly (Provenance & { update?: Uint8Array })[]
): Run[] {
  const runs: Run[] = [];
  for (const job of jobs) {
    const last = runs.at(-1);
    if (last && identity(last) === identity(job)) {
      if (job.update) last.updates.push(job.update);
      if (last.clientAction && job.clientAction) {
        const targets = new Map<string, unknown>();
        for (const target of [
          ...(last.clientAction.targets ?? []),
          ...(job.clientAction.targets ?? []),
        ]) {
          const key = JSON.stringify(target);
          targets.delete(key);
          targets.set(key, target);
        }
        last.clientAction = {
          ...last.clientAction,
          targets: [...targets.values()].slice(-64),
        };
      }
      if (last.agent && job.agent) {
        const targets = new Map<string, AgentDocUpdate['targets'][number]>();
        for (const target of [...last.agent.targets, ...job.agent.targets])
          targets.set(JSON.stringify(target), target);
        last.agent = { ...last.agent, targets: [...targets.values()] };
      }
      continue;
    }
    runs.push({
      ...(job.agent ? { agent: job.agent } : {}),
      ...(job.clientAction ? { clientAction: job.clientAction } : {}),
      updates: job.update ? [job.update] : [],
    });
  }
  return runs;
}

function identity(value: Provenance): string {
  const ref = value.clientAction;
  const agent = value.agent;
  return JSON.stringify([
    agent?.ownerUserId,
    agent?.runId,
    agent?.stepId,
    agent?.agent,
    ref?.sessionId,
    ref?.toolCallId,
    ref?.clientInstanceId,
    ref?.capability,
    ref?.runId,
    ref?.stepId,
  ]);
}
